<template>
  <path
    d="M21 2.00018H3C1.9 2.00018 1 2.90018 1 4.00018V16.0002C1 17.1002 1.9 18.0002 3 18.0002H10V20.0002H9C8.45 20.0002 8 20.4502 8 21.0002C8 21.5502 8.45 22.0002 9 22.0002H15C15.55 22.0002 16 21.5502 16 21.0002C16 20.4502 15.55 20.0002 15 20.0002H14V18.0002H21C22.1 18.0002 23 17.1002 23 16.0002V4.00018C23 2.90018 22.1 2.00018 21 2.00018ZM20 16.0002H4C3.45 16.0002 3 15.5502 3 15.0002V5.00018C3 4.45018 3.45 4.00018 4 4.00018H20C20.55 4.00018 21 4.45018 21 5.00018V15.0002C21 15.5502 20.55 16.0002 20 16.0002Z"
  />
</template>
